import { useQuery } from "@tanstack/react-query";

import userViewGuard from "~/hooks/useViewPermssionsCheck.tsx";
import { quotaQueries } from "~/modules/quota/api/quota/quotaQueries.ts";
import QuotasIndexView from "~/modules/quota/components/QuotasIndexView/QuotasIndexView.tsx";
import LoadingPage from "~/pages/LoadingPage.tsx";
import { PermissionNames } from "~/types/entityNames.ts";

const QuotaDetailsPage = () => {
	const guard = userViewGuard([PermissionNames.CanManageProjects, PermissionNames.CanViewInvoices]);
	if (guard) return guard;

	const {
		data: quotasData,
		isLoading: quotasIsLoading,
	} = useQuery(quotaQueries.index());


	if (quotasIsLoading) return <LoadingPage />;
	if (!quotasData) return null;

	return <QuotasIndexView quotas={quotasData}/>;
};

export default QuotaDetailsPage;